import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchMoreDetailsDone = (state, { payload }) => {
    return {...state, moreData: payload, isMoreDetails: true }
}

const clearMoreDetailsDone = () => {
    return initialState
}
const isFetchMoreDetailsLoading = (state) => {
    return { ...state, isEnableLoader: true}
}
const closeFetchMoreDetailsLoading = (state) => {
    return { ...state, isEnableLoader: false}
}
const initialState = {
    moreData: {},
    isMoreDetails : false,
    isEnableLoader : false
};

export default createReducer(initialState, {
    [TYPES.FETCH_MORE_DETAILS_DONE]: fetchMoreDetailsDone,
    [TYPES.CLEAR_MORE_DETAILS_DONE]: clearMoreDetailsDone,
    [TYPES.IS_FETCH_MORE_DETAILS_LOADING]: isFetchMoreDetailsLoading,
    [TYPES.CLOSE_FETCH_MORE_DETAILS_LOADING]: closeFetchMoreDetailsLoading
});
